module.exports = __webpack_public_path__ + "static/Costco-fba5e7d53f20a6ba6b55c78e8ef74062.jpeg";